import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {SubscriptionStatusModel} from '../../types';
import {useCreateAuthenticatedFetch} from '../useCreateAuthenticatedFetch';
import baseUrl from '../baseUrl';
import {handleResponse} from '../handleResponse';

export const useGetSubscriptionStatus = (): UseQueryResult<
    SubscriptionStatusModel,
    Error
> => {
    const authenticatedFetch = useCreateAuthenticatedFetch();

    return useQuery({
        queryKey: ['subscription-status'],
        queryFn: async () => {
            const response = await authenticatedFetch(
                `${baseUrl}/api/customers/current/subscription`
            );
            return handleResponse<SubscriptionStatusModel>(response);
        }
    });
};

export default useGetSubscriptionStatus;
